import React from 'react';
import { Link } from 'react-router-dom';

// Material UI
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';

// Icons
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

// Components
import { CardDetail } from '@arredo/reactjs-ui';

const RelatedOrderDetail = ({ originalOrderId, newOrderIds }) =>
    <CardDetail title='ORDENES RELACIONADAS' divider>
        <Grid container spacing={1} justifyContent='space-between'>
            {
                originalOrderId &&
                <Grid>
                    <Tooltip title={`OrderId: ${originalOrderId}`}>
                        <Button
                            startIcon={<ArrowLeftIcon />}
                            variant='outlined'
                            color='primary'
                            component={Link}
                            to={`/orders/detail/${originalOrderId}`}
                        >
                            Orden original
                        </Button>
                    </Tooltip>
                </Grid>
            }
            {
                newOrderIds && !!newOrderIds.length &&
                newOrderIds.map(id =>
                    <Grid key={id}>
                        <Tooltip title={`OrderId: ${id}`}>
                            <Button
                                endIcon={<ArrowRightIcon />}
                                variant='outlined'
                                color='primary'
                                component={Link}
                                to={`/orders/detail/${id}`}
                            >
                                Nueva orden
                            </Button>
                        </Tooltip>
                    </Grid>
                )
            }
        </Grid>
    </CardDetail>

export default RelatedOrderDetail;